'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _commonFormsy = require('../common-formsy');

var _utils = require('../../utils');

var _constants = require('../../constants');

var _commonPriorFundings = require('../common-prior-fundings');

var _GenericFeeRow = require('./GenericFeeRow');

var _GenericFeeRow2 = _interopRequireDefault(_GenericFeeRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatMoney = _utils.FormattingUtils.formatMoney;
var LIEN_ACTIONS = _constants.AppConstants.LIEN_ACTIONS;

var LegalFundingLienModalFormGroup = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(LegalFundingLienModalFormGroup, _Component);

  function LegalFundingLienModalFormGroup() {
    _classCallCheck(this, LegalFundingLienModalFormGroup);

    return _possibleConstructorReturn(this, (LegalFundingLienModalFormGroup.__proto__ || Object.getPrototypeOf(LegalFundingLienModalFormGroup)).apply(this, arguments));
  }

  _createClass(LegalFundingLienModalFormGroup, [{
    key: 'renderNonFlatFeeRow',
    value: function renderNonFlatFeeRow(fee, idx) {
      return _react2.default.createElement(_GenericFeeRow2.default, { key: idx, fee: fee, idx: idx, label: 'Fee' });
    }
  }, {
    key: 'renderFlatFeeRow',
    value: function renderFlatFeeRow(fee, idx) {
      var lien = this.props.lien;

      return _react2.default.createElement(_GenericFeeRow2.default, { key: idx, fee: fee, idx: lien.feesNonFlat().length + idx, label: 'Flat Fee' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          addBuyout = _props.addBuyout,
          application = _props.application,
          currentAction = _props.currentAction,
          errorMessage = _props.errorMessage,
          lien = _props.lien,
          priorFunding = _props.priorFunding,
          publishedOrSelectedPresets = _props.publishedOrSelectedPresets,
          showOnly = _props.showOnly,
          agreement_date = lien.agreement_date,
          funding_amount = lien.funding_amount,
          interest_start_date = lien.interest_start_date,
          preset_contract_template = lien.preset_contract_template,
          calculatedPrincipal = lien.calculatedPrincipal,
          defaultPresetContractTemplate = (0, _get3.default)(publishedOrSelectedPresets()[0], 'id', ''),
          isConfirmed = [LIEN_ACTIONS.revise, LIEN_ACTIONS.finalize].includes(currentAction);


      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Contract Template'
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(_commonFormsy.Dropdown, {
            name: 'preset_contract_template',
            label: 'Contract Template',
            options: publishedOrSelectedPresets(),
            value: preset_contract_template || defaultPresetContractTemplate,
            required: true
          })
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Principal'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_commonFormsy.Input, {
              type: 'hidden',
              name: 'is_confirmed',
              value: isConfirmed
            }),
            application && _react2.default.createElement(_commonFormsy.Input, {
              type: 'hidden',
              name: 'link_application',
              value: application.id
            }),
            _react2.default.createElement(_commonFormsy.Input, {
              addonAfter: _react2.default.createElement(
                _InputGroup2.default.Addon,
                null,
                '$'
              ),
              name: 'funding_amount',
              label: 'Amount to Plaintiff',
              validations: {
                isNumeric: true,
                isPositive: true,
                isWithinDecimalPlaces: 2
              },
              validationErrors: {
                isNumeric: 'Amount to Plaintiff must be a valid amount.',
                isPositive: 'Amount to Plaintiff must be positive.',
                isWithinDecimalPlaces: 'Amount to Plaintiff can not have more than 2 decimal places.'
              },
              value: funding_amount,
              type: 'number',
              required: true
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          priorFunding ? _react2.default.createElement(_commonPriorFundings.PriorFundingFormGroup, {
            priorFunding: priorFunding,
            required: true
          }) : _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_buyout', bsStyle: 'link', disabled: showOnly, onClick: addBuyout },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add Buyout'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          lien.feesNonFlat().map(this.renderNonFlatFeeRow),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_fee', bsStyle: 'link', disabled: showOnly, onClick: lien.addNonFlatFee },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add fee'
              )
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'fees-total' },
            'Total ',
            _react2.default.createElement(
              'span',
              { className: 'number' },
              formatMoney(calculatedPrincipal(priorFunding))
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Flat Fees'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          lien.feesFlat().map(this.renderFlatFeeRow),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_flat_fee', bsStyle: 'link', disabled: showOnly, onClick: lien.addFlatFee },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add flat fee'
              )
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Contract Dates'
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'form-group-merged' },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.DateInput, {
                name: 'agreement_date',
                label: 'Agreement Date',
                positionTop: true,
                value: agreement_date,
                required: true
              })
            ),
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.DateInput, {
                name: 'interest_start_date',
                label: 'Interest Start Date',
                positionTop: true,
                value: interest_start_date,
                required: true
              })
            )
          )
        ),
        errorMessage && _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-danger' },
              errorMessage
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LegalFundingLienModalFormGroup;
}(_react.Component), _class2.propTypes = {
  addBuyout: _propTypes2.default.func.isRequired,
  application: _propTypes2.default.object,
  currentAction: _propTypes2.default.string,
  errorMessage: _propTypes2.default.string,
  lien: _propTypes2.default.object,
  priorFunding: _propTypes2.default.object,
  publishedOrSelectedPresets: _propTypes2.default.func,
  showOnly: _propTypes2.default.bool
}, _temp)) || _class) || _class;

var _default = LegalFundingLienModalFormGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(LIEN_ACTIONS, 'LIEN_ACTIONS', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(LegalFundingLienModalFormGroup, 'LegalFundingLienModalFormGroup', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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